module.exports = __webpack_public_path__ + "img/fado.4257de42.jpg";